
import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';
import { extendedColumnTypes } from 'app/shared/utils/column-type.util';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';

export const azureDataLakeStoreCosmosStructuredStreamFileDatasetMetadata: IDatasetTypeMetadata = {
    type: adfModelTypeMap.azureDataLakeStoreCosmosStructuredStream.datasetType,
    supportLinkedServiceTypes: [adfModelTypeMap.azureDataLakeStoreCosmosStructuredStream.linkedServiceType],
    displayName: stringResources.AzureDataLakeStoreCosmosStructuredStream_DisplayText,
    datasetKind: 'file',
    isSource: true,
    isSink: false,
    icon: {
        className: 'svg-i-100x100-AzureDataLake'
    },
    isFirstClass: true,
    category: ['Azure'],
    supportCreatedAsV2: true,
    supportGetMetadataActivity: true,
    supportRootFolder: true,
    supportDataTypes: extendedColumnTypes
};
